import { useMFEContext } from '~/components/MFEProvider';
import useIsHalGUI from '~/hooks/useIsHalGUI';

const useAMRevamp = () => {
  const {
    // @ts-expect-error
    brandFromJWT,
  } = useMFEContext();
  const isHalGui = useIsHalGUI();
  const isBlueHost = brandFromJWT?.toLowerCase() === 'bluehost';
  const isHostgator = brandFromJWT?.toLowerCase() === 'hostgator';
  const isAMRevamp = !isHalGui && (isBlueHost || isHostgator);

  return { isAMRevamp };
};

export default useAMRevamp;
